<template>

    <vs-card class="w-full" style="min-height: 150px; ">
        <expense-detail :expense_id="expense_id" />
        <vs-row vs-type="flex" vs-justify="end" class="mb-4">
            <vs-col vs-w="12" style="display: inline-flex">
                <div class="con-input-search vs-table--search">
                    <input class="input-search vs-table--search-input mt-1 w-full" type="text" style="font-size: 1.5em;"
                        v-model="text" @keypress.enter="search" :placeholder="$t('search') | capitalize">
                    <vs-icon icon="search"></vs-icon>
                </div>
            </vs-col>
        </vs-row>
  
        <vs-row>
            <vs-col>
                <table class="sticky-table">
                    <thead>
                        <tr>
                            <th class="sticky-table-th text-left" style="width: 20vw;">
                                 {{ $t('category') }} ({{ budget.title }})
                                 </th>
                            <th class="sticky-table-th text-center" style="width: 5vw;"> {{ month != '' ? month : '-' }}
                            </th>
                            <th class="sticky-table-th text-center" style="width: 5vw;"> Acumulado <br> a {{ month != ''
                                ? month : '-' }} </th>
                            <th class="sticky-table-th text-center" style="width: 5vw;"> Presupuesto <br> Mensual </th>
                            <th class="sticky-table-th text-center" style="width: 5vw;"> Presupuesto <br> Acumulado
                            </th>
                            <th class="sticky-table-th text-center" style="width: 5vw;"> Variación <br>Absoluta </th>
                            <th class="sticky-table-th text-center" style="width: 5vw;"> Variación Porcentual <br> ({{
                                month != '' ?
                                    month : '-'
                                     }}) </th>
                            <th class="sticky-table-th text-center" style="width: 5vw;"> Variación Absoluta Acumulada
                            </th>
                            <th class="sticky-table-th text-center" style="width: 5vw;"> Variación Porcentual
                                (Acumulada) </th>
                            <th class="sticky-table-th text-center" style="width: 5vw;"> Utilizacion Mensual <br> ({{
                                formatCell(budget.period.utilization_month, '%') }}) </th>
                            <th class="sticky-table-th text-center" style="width: 5vw;"> Utilizacion Acumulada <br> ({{
                                formatCell(budget.period.utilization_accumulated, '%') }})</th>
                        </tr>
                    </thead>
                    <tbody id="table-loading" class="vs-con-loading__container">
                        <template v-for="(item, indextr) in budget.filtered">
                            <tr :key="indextr" @click="item.show = !item.show"
                                :class="[item.show ? 'font-bold' : '', 'sticky-table-tr']">
                                <td class="sticky-table-td">
                                    <vs-icon :icon="item.show ? 'remove' : 'add'" :disabled="item.expenses.length > 0"
                                        class="p-1"></vs-icon>{{ item.CategoryName }} ({{ item.expenses.length }})
                                </td>
                                <td class="sticky-table-td text-right">
                                    {{ formatCell(item.expense_total_month, '$') }}
                                </td>
                                <td class="sticky-table-td text-right">
                                    {{ formatCell(item.expense_accumulated, '$') }}
                                </td>
                                <td class="sticky-table-td text-right">
                                    {{ formatCell(item.budget_total_month, '$') }}
                                </td>
                                <td class="sticky-table-td text-right">
                                    {{ formatCell(item.budget_accumulated, '$') }}
                                </td>
                                <td
                                    :class="[backgroundColor(item.expense_total_month, item.budget_total_month), 'text-right', 'sticky-table-td']">
                                    {{ formatCell(item.variation_month, '$') }}
                                </td>
                                <td
                                    :class="[backgroundColor(item.expense_total_month, item.budget_total_month), 'text-right', 'sticky-table-td']">
                                    {{ formatCell(item.variation_porcentage_month, '%') }}
                                </td>
                                <td
                                    :class="[backgroundColor(item.expense_accumulated, item.budget_accumulated), 'text-right', 'sticky-table-td']">
                                    {{ formatCell(item.variation_accumulated, '$') }}
                                </td>
                                <td
                                    :class="[backgroundColor(item.expense_accumulated, item.budget_accumulated), 'text-right', 'sticky-table-td']">
                                    {{ formatCell(item.variation_porcentage_accumulated, '%') }}
                                </td>
                                <td
                                    :class="[utilizationBg(item.expense_total_month, item.budget_total_month, budget.period.utilization_month), 'text-right', 'sticky-table-td']">
                                    {{ formatCell(item.utilization_month, '%') }}
                                </td>
                                <td
                                    :class="[utilizationBg(item.expense_accumulated, item.budget_accumulated,  budget.period.utilization_accumulated), 'text-right', 'sticky-table-td']">
                                    {{ formatCell(item.utilization_accumulated, '%') }}
                                </td>

                            </tr>
                            <tr v-if="item.expenses.length > 0 && item.show">
                                <td colspan="11">
                                    <table class="w-full expand-table">
                                        <thead>
                                            <tr>
                                                <th class="text-center" style="width: 30vw !important;">{{ $t('vendor')
                                                    | capitalize }}</th>
                                                <th class="text-center">{{ $t('folio') | capitalize }}</th>
                                                <th class="text-center">{{ $t('date') | capitalize }}</th>
                                                <th class="text-center">{{ $t('date') | capitalize }} ({{
                                                    $t('cash_request') | capitalize }})
                                                </th>
                                                <th class="text-center">{{ $t('total') | capitalize }}</th>
                                                <th class="text-center">{{ $t('currency') | capitalize }}</th>
                                                <th class="text-center"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(expense, index) in item.expenses" :key="index">
                                                <td class="text-left" style="width: 30vw !important;">{{
                                                    expense.vendor_name }} </td>
                                                <td class="text-center">{{ expense.folio }} </td>
                                                <td class="text-center">{{ formatDate(expense.expense_date) }}</td>
                                                <td class="text-center">{{ formatDate(expense.invoice_date) }} </td>
                                                <td class="text-right">$ {{ formatNumber(expense.total, 2) }} </td>
                                                <td class="text-center">{{ expense.currency }} </td>
                                                <td class="text-center">
                                                    <action-icon class="mx-1" icon="ArrowRightCircleIcon"
                                                        :tooltip="$t('details')"
                                                        @click="expenseDetail(expense.expense_id)" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </template>

                        <tr v-if="budget.data.length > 0" class="sticky-table-tr">
                            <td style="width: 20vw;" class="sticky-table-td text-right font-bold">
                                {{ $t('total') | capitalize }}
                            </td>
                            <td style="width: 10vw;" class="sticky-table-td text-right font-bold">
                                {{ formatCell(budget.totals.expense_total_month, '$') }}
                            </td>
                            <td style="width: 10vw;" class="sticky-table-td text-right font-bold">
                                {{ formatCell(budget.totals.expense_accumulated, '$') }}
                            </td>
                            <td style="width: 10vw;" class="sticky-table-td text-right font-bold">
                                {{ formatCell(budget.totals.budget_total_month, '$') }}
                            </td>
                            <td style="width: 10vw;" class="sticky-table-td text-right font-bold">
                                {{ formatCell(budget.totals.budget_accumulated, '$') }}
                            </td>
                            <td style="width: 10vw;" :class="[backgroundColor(budget.totals.expense_total_month, budget.totals.budget_total_month), 'text-right', 'font-bold', 'sticky-table-td']">
                                {{ formatCell(budget.totals.variation_month, '$') }}
                            </td>
                            <td style="width: 10vw;" :class="[backgroundColor(budget.totals.expense_total_month, budget.totals.budget_total_month), 'text-right', 'font-bold', 'sticky-table-td']">
                                {{ formatCell(budget.totals.variation_porcentage_month, '%') }}
                            </td>
                            <td style="width: 10vw;" :class="[backgroundColor(budget.totals.expense_accumulated, budget.totals.budget_accumulated), 'text-right', 'font-bold', 'sticky-table-td']">
                                {{ formatCell(budget.totals.variation_accumulated, '$') }}
                            </td>
                            <td style="width: 10vw;" :class="[backgroundColor(budget.totals.expense_accumulated, budget.totals.budget_accumulated), 'text-right', 'font-bold', 'sticky-table-td']">
                                {{ formatCell(budget.totals.variation_porcentage_accumulated, '%') }}
                            </td>
                            <td :class="[utilizationBg(budget.totals.expense_total_month, budget.totals.budget_total_month, budget.period.utilization_month), 'text-right', 'font-bold', 'sticky-table-td']">
                                {{ formatCell(budget.totals.utilization_month, '%') }}
                            </td>
                            <td :class="[utilizationBg(budget.totals.expense_accumulated, budget.totals.budget_accumulated, budget.period.utilization_accumulated), 'text-right', 'font-bold', 'sticky-table-td']">
                                {{ formatCell(budget.totals.utilization_accumulated, '%') }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </vs-col>
        </vs-row>
    </vs-card>
</template>
<script>
import loading from '@/mixins/Loading'
import ExpenseDetail from '@/views/apps/accounting/components/ExpenseDetail.vue'
import ActionIcon from '@/views/qb-components/actions/ActionIcon.vue'
import { type } from 'vuesax'

export default {
    components: {
        ExpenseDetail,
        ActionIcon
    },
    data() {
        return {
            expense_id: '',
            text: '',
        }
    },
    methods: {
        formatCell(value, sim) {
            if (value == '0') {
                return '-'
            }
            return `${sim == '$' ? '$' : ''} ${this.formatNumber(value, 2)} ${sim == '%' ? '%' : ''}`
        },
        expenseDetail(expense_id) {
            this.expense_id = expense_id
            this.$store.dispatch('toggleSidebar', 'expense-detail')
        },
        backgroundColor(value1, value2) {
            const x = Number(value1)
            const y = Number(value2)
            if (x == 0 && y == 0) {
                return 'col-grey';
            }
            let css = '';

            if (x > y) {
                css = 'col-danger';
            }

            if (x <= y) {
                css = 'col-success';
            }

            return css;
        },
        utilizationBg(value1, value2, value3) {
            const x = Number(value1);
            const y = Number(value2);
            const p = Number(value3);

            if (x == 0 || y == 0) {
                return 'col-grey';
            }
            const result = (value1 / value2) * 100

            let css = ''
            if (result <= p) {
                css = 'col-success';
            }

            if (result > p && result <= 100) {
                css = 'col-warning';
            }


            if (result > 100) {
                css = 'col-danger';
            }

            return css;

        },
        search() {
            this.$emit('search', this.text)
        }

    },
    mixins: [loading],
    watch: {
        loading(val) {
            if (val) {
                this.openLoading('table-loading')
            } else {
                this.closeLoading('table-loading')
            }
        },
    },
    props: {
        budget:{
            type:Object,
            default:() => ({
                title:'',
                data: [],
                filtered: [],
                totals: {
                    expense_total_month: 0,
                    expense_accumulated: 0,
                    budget_total_month: 0,
                    budget_accumulated: 0,
                    variation_month: 0,
                    variation_porcentage_month: 0,
                    variation_accumulated: 0,
                    variation_porcentage_accumulated: 0,
                    utilization_month: 0,
                    utilization_accumulated: 0
                },
                period: {
                    weeks_no_month: 0,
                    week_no_year: 0,
                    total_weeks_month: 0,
                    total_weeks_year: 0,
                    utilization_month: 0,
                    utilization_accumulated: 0
                },
            })
        },
        loading: {
            type: Boolean,
            default: false
        },
        month: {
          type: String,
          default: '',
      },
    },
}
</script>

<style scoped>
.col-success {
    background: #28c76f;
    color: #ffffff;
}

.col-danger {
    background: #bc1300;
    color: #ffffff;
}

.col-warning {
    background: #FF9F43;
    color: #ffffff;
}

.col-grey {
    background: #b8c2cc;
    color: #000000;
}

/* .expand-table tr:nth-child(even) {
    background-color: #f2f2f2;
  } */

.expand-table {
    background-color: #f2f2f2;
}

.expand-table th {
    color: #bc1300;
}

.expand-table tr:hover {
    font-weight: bold;
}
</style>